export enum CampagneStatut {
  ARCHIVEE = 'ARCHIVEE',
  EN_COURS = 'EN_COURS',
  A_VENIR = 'A_VENIR',
}